/**
 * 判断一个对象是否为普通对象
 * @param o 待判断的对象
 * @returns 如果是普通对象则返回 true，否则返回 false
 */ function isObject(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
/**
 * 判断一个对象是否为普通对象
 * @param o 待判断的对象
 * @returns 如果是普通对象则返回 true，否则返回 false
 */ export function isPlainObject(o) {
    var ctor, prot;
    // 如果不是对象，则不是普通对象
    if (isObject(o) === false) return false;
    // 如果对象没有修改过构造函数，则认为是普通对象
    ctor = o.constructor;
    if (ctor === undefined) return true;
    // 如果对象修改过构造函数的原型，则认为是普通对象
    prot = ctor.prototype;
    if (isObject(prot) === false) return false;
    // 如果构造函数的原型没有 isPrototypeOf 方法，则不是普通对象
    if (prot.hasOwnProperty("isPrototypeOf") === false) {
        return false;
    }
    // 最终认为是普通对象
    return true;
}
